exports.f = {}.propertyIsEnumerable;